<template>
    <v-container fluid>
        <v-snackbar
            v-model="showToast"
            color="red lighten-1"
            text
            top
            right
            rounded
            style="margin-top: 75px"
        >
            {{ toastMsg }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red lighten-1"
                    text
                    v-bind="attrs"
                    @click="showToast = false"
                >
                    <v-icon color="red lighten-1">
                        close
                    </v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row>
            <v-col>
                <v-toolbar
                    id="billing-code-toolbar"
                    flat
                >
                    <v-row>
                        <v-col cols="6">
                            <v-toolbar-title> Billing Code </v-toolbar-title>
                        </v-col>
                        <v-col
                            cols="6"
                            class="text-right"
                        >
                            <AddBillingCode model-type="Add" />
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row
            class="mt-0"
            :no-gutters="this.$vuetify.breakpoint.xs"
        >
            <v-col>
                <v-data-table
                    id="billing-code-table"
                    item-key="rowid"
                    :headers="headers"
                    :items="companyBillingCodes"
                    fixed-header
                    hide-default-footer
                    dense
                >
                    <template v-slot:[`item.code`]="{ item }">
                        {{ item.code.toUpperCase() }}
                    </template> 
                    <template v-slot:[`item.amount`]="{ item }">
                        {{ item.amount }}
                    </template> 
                    <template v-slot:[`item.edit`]="{ item }">
                        <AddBillingCode
                            :billing-code-details="item"
                            model-type="Edit"
                        />
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <DeleteBillingCode
                            :billing-code="item"
                            model-type="Delete"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import AddBillingCode from './AddBillingCode';
import DeleteBillingCode from './DeleteBillingCode';
import CompanyBillingMixin from '@/mixins/CompanyBillingMixin';

export default {
    components: {
        AddBillingCode,
        DeleteBillingCode,
    },
    mixins: [
        CompanyBillingMixin
    ],
    data: () => ({
        showToast: false,
        toastMsg: '',
        headers: [
            {
                text: 'Billing Code',
                align: 'left',
                sortable: true,
                value: 'code',
            },
            {
                text: 'Description',
                align: 'left',
                sortable: false,
                value: 'description',
            },
            {
                text: '$Amount',
                align: 'left',
                sortable: true,
                value: 'amount',
            },
            {   text: 'Edit',
                value: 'edit',
                sortable: false
            },
            {
                text: 'Delete',
                value: 'delete',
                sortable: false
            },
        ],
    }),    
};
</script>
<style scoped>
.mmobile-billing-code-action-bar {
  /* display: flex;
    justify-content: center; */
  position: fixed;
  bottom: 0px;
  width: 100%;
  text-align: center;
}
.mobile-billing-code-action-bar .v-btn {
  width: 170px;
}
.table-header {
  background-color: #a72251;
}
</style>
